module.exports = __webpack_public_path__ + "media/images/wishlistOnWhite-c83fb12847d2a366a8ff80b6b1a04835.svg";